import {useState} from "react";
import TopBarDropdown from 'factor-lib/TopBar/TopBarDropdown';
import TopBarUserDropDown from "./TopBarUserDropDown";
import './TopBarUserRightDesktop.scss';

const TopBarUserRightDesktop = (
    {
        className,
        userName
    }: {
        className?: string;
        userName: string;
    }
) => {
    const [showUserDropdown, setShowUserDropdown] = useState(false);

    return (
        <div className={`${!!className ? ` ${className}` : ''}`}
             style={{
                 whiteSpace: 'nowrap'
             }}
             onClick={() => setShowUserDropdown(!showUserDropdown)}
        >
            <TopBarDropdown buttonNode={
                                <div className='p-clickable'>
                                    <div className='level p-user-name'>
                                        { userName }
                                        <div className='caret'/>
                                    </div>
                                </div>
                            }
                            expandNode={(showUserDropdown && <TopBarUserDropDown />) || null}/>
        </div>
    );
}

export default TopBarUserRightDesktop;
